import { useState, useEffect, useCallback } from 'react';
import MessagingAPI from '../services/MessagingAPI';

export function useCommunicationPolicy(threadId) {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPolicy = useCallback(async () => {
    if (!threadId) { setPolicy(null); return; }
    setLoading(true);
    try {
      const data = await MessagingAPI.getThreadPolicy(threadId);
      setPolicy(data);
    } catch {
      setPolicy(null);
    } finally {
      setLoading(false);
    }
  }, [threadId]);

  useEffect(() => { fetchPolicy(); }, [fetchPolicy]);

  return { policy, loading, refetch: fetchPolicy };
}
